// Tiny helper to DRY the await import + return pattern

import React from 'react';

export const createLazyRoute =
  <P = Record<string, unknown>,>(
    loader: () => Promise<{ default: React.ComponentType<P> }>,
  ) =>
  async () => {
    const module = await loader();
    return { Component: module.default as React.ComponentType };
  };

// Reusable lazy loaders using makeLazy (behavior unchanged)
export const lazyCustomCallback = createLazyRoute(
  () => import(/* webpackPrefetch: true */ '../CustomCallback/CustomCallback'),
);
export const lazyLogin = createLazyRoute(
  () => import(/* webpackPrefetch: true */ '../LoginWidget/Login'),
);
export const lazyApp = createLazyRoute(
  () => import(/* webpackPrefetch: true */ '../App'),
);
export const lazyDashboard = createLazyRoute(
  () => import(/* webpackPrefetch: true */ '../Dashboard'),
);
export const lazyCreateCaseModal = createLazyRoute(
  () => import(/* webpackPrefetch: true */ '../CreateCase/create-case-modal'),
);
export const lazyFeatureFlags = createLazyRoute(
  () => import(/* webpackPrefetch: true */ '../FeatureFlags/FeatureFlags'),
);
export const lazyRedirectToAdminPersonal = createLazyRoute(
  () => import(/* webpackPrefetch: true */ './redirect-to-admin-personal'),
);
